module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"education":"Uddannelse","noEducationRecords":"Ingen Uddannelsesoptegnelser"}}')
  delete Component.options._Ctor
}
